<!-- 导航 -->
<template>
  <div class="btn-TopFBshare" v-if="deviceType() == 'wap'">
    <a
      :href="store.state.articlesData['fbPageCN']"
      target="_blank"
      class="official_fb"
    >
    </a>
  </div>
  <div class="nav_btn" :class="deviceType()" @click="showNav()"></div>
  <Transition name="fade">
    <div v-if="nav" class="fix fade-element" @click="showNav(false)"></div>
  </Transition>

  <Transition name="fade">
    <div
      v-if="nav"
      class="nav top-move fade-element cn"
      :class="[activityEnd ? 'activityEnd' : '']"
    >
      <div class="close" @click="showNav(false)"></div>
      <div class="waplogo"></div>
      <!-- 菜单 -->
      <ul>
        <li class="on" @click="showNav(false)" v-if="position == 'news'">
          <router-link to="/news" class="official_guide"></router-link>
        </li>
        <li v-else @click="showNav(false)">
          <router-link to="/news" class="official_guide"></router-link>
        </li>
        <li @click="showNav(false)">
          <a
            :href="store.state.articlesData.carveUpEN"
            target="_blank"
            class="official_challenge"
          ></a>
        </li>
        <li>
          <a
            class="official_fb"
            :href="store.state.articlesData.likeUrl"
            target="_blank"
          ></a>
        </li>
        <li>
          <a
            class="official_charge"
            :href="store.state.articlesData.payUrl"
            target="_blank"
          ></a>
        </li>
      </ul>

      <!-- 下载按钮 -->
      <down-info
        :position="deviceType() + 'menuDown'"
        :iosCounts="'official_ios'"
        :androidCounts="'official_gp'"
        :finger="1"
      ></down-info>

      <!-- 分享 -->
      <div class="share">
        <a :href="store.state.articlesData['fbPageCN']" target="_blank">
          <img :class="'official_fb'" src="../../../assets/images/yy/fb.png" />
        </a>
        <a :href="store.state.articlesData.discordShare" target="_blank">
          <img
            :class="'official_gamer'"
            src="../../../assets/images/yy/dc.png"
          />
        </a>
        <a @click="fillUpShare(ShareData)" target="_blank">
          <img
            :class="'official_share'"
            src="../../../assets/images/yy/line.png"
          />
        </a>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { defineProps, ref } from "vue";
import { shareFB } from "@/util/share";
import { deviceType } from "@/util/base";
import downInfo from "@/components/down.vue";

import { useStore } from "vuex";
const store = useStore();

defineProps(["ShareData", "activityEnd", "position"]);
const nav = ref(false);
const slide = ref(true);

const showNav = (type) => {
  nav.value = type !== undefined ? type : !nav.value;
};

const scrollToTop = () => {
  const scrollTops =
    document.documentElement.scrollHeight / document.documentElement.scrollTop;
  if (scrollTops < 4.5 && deviceType() == "pc") {
    slide.value = false;
  } else {
    slide.value = true;
  }
};
window.addEventListener("scroll", scrollToTop);

const fillUpShare = (data) => {
  const shareLink = window.location.href;
  let shareTitle = "";
  let shareImg =
    "https://gw-gat.res.etolies.com/resources/tkingdoms/share/share.jpeg";
  for (const item of data) {
    if (item.label === "shareTitle") {
      shareTitle = item.content;
    }
    // if (item.label === "shareImg") {
    //   shareImg = item.content;
    // }
  }
  shareFB(shareLink, shareTitle, shareImg);
};
</script>

<style lang="scss" scoped>
.btn-TopFBshare {
  position: fixed;
  right: 1.55rem;
  top: 0.15rem;
  width: 0.87rem;
  height: 0.93rem;
  background: url("../../../assets/images/yygw/btn-fbShare.png") no-repeat
    center top;
  background-size: 100% auto;
  z-index: 10;
  cursor: pointer;

  a {
    width: 100%;
    height: 100%;
    display: block;
  }
}
.nav_btn {
  position: fixed;
  right: 0.15rem;
  top: 0.15rem;
  width: 0.87rem;
  height: 0.93rem;
  background: url("../../../assets/images/yy/nav.png") no-repeat center top;
  background-size: 100% auto;
  z-index: 10;
  cursor: pointer;
  &.wap {
    width: 0.9rem;
    height: 0.96rem;
  }
}
.nav {
  position: fixed;
  z-index: 1002;
  width: 100%;
  min-height: 7.33rem;
  top: 0;

  .waplogo {
    width: 3.38rem;
    height: 1.5rem;
    background: url("../../../assets/images/yy/logo-wap.png") no-repeat center
      top;
    background-size: contain;
    margin: 0.49rem auto 0.4rem;
  }

  ul {
    font-size: 0.3rem;
    height: 3.79rem;
    background: url("../../../assets/images/yygw/wap-nav.png") no-repeat center
      top;
    background-size: contain;

    li {
      cursor: pointer;
      text-align: center;
      color: #ffe98c;
      // text-shadow: #333333 2px 1px 1px;
      line-height: 0.94rem;
      height: 0.94rem;

      a {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
  .down {
    display: flex;
    justify-content: center;
  }
  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 0.5rem;
    height: 0.5rem;
    cursor: pointer;
  }

  .share {
    display: flex;
    align-items: center;
    justify-content: center;

    height: 1.04rem;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 0.45rem;
      width: 1.04rem;
      img {
        width: 1.04rem;
      }
    }
  }
}
</style>
